import { CredenzaSuiClient } from '@credenza3/contracts-lib-sui/client'
import { CredenzaSuiSigner, getCredenzaSuiSigner } from '@credenza3/contracts-lib-sui/signer'
import { get } from 'svelte/store'

import { sdk } from '@lib/sdk/sdk'
import { NetworkTypes } from '@packages/utils/enums'
import { suiPackageStore } from '@packages/stores'
import { configStore } from '@src/stores/config'

let signer: CredenzaSuiSigner
const clientsMap = new Map<string, CredenzaSuiClient>()
const initSuiSigner = async (accessToken: string) => {
  if (!accessToken || signer) return
  signer = await getCredenzaSuiSigner({ accessToken, sponsoredTransactions: true })
}

const clientCacheKey = (packageId: string, networkType: string) =>
  `${networkType.toLowerCase()}:${packageId}`

const initSuiClient = async (
  packageId: string,
  networkType: string = NetworkTypes.MAINNET,
): Promise<CredenzaSuiClient> => {
  if (!signer) await initSuiSigner(sdk.getAccessToken() as string)

  const cacheKey = clientCacheKey(packageId, networkType)
  if (clientsMap.has(cacheKey)) return clientsMap.get(cacheKey) as CredenzaSuiClient

  const client = new CredenzaSuiClient({
    environment: networkType.toUpperCase(),
    packageId,
    signer,
  })

  clientsMap.set(cacheKey, client)
  return client
}

type SuiGrpcClient = Awaited<ReturnType<typeof initSuiClient>>['suiGrpcClient']

const getSuiClient = async (): Promise<SuiGrpcClient> => {
  const { suiNetwork } = get(configStore)
  const client = await initSuiClient(get(suiPackageStore), suiNetwork)
  return client.suiGrpcClient
}

export { initSuiSigner, initSuiClient, getSuiClient }
